import request from '@/plugins/axios'

//获取图集列表
export function listAtlas(params) {
  return request({
    url: '/atlas/listAtlas',
    method: 'get',
    params
  })
}

//添加图集
export function addAtlas(data) {
  return request({
    url: '/atlas/addAtlas',
    method: 'post',
    data
  })
}

//删除图集
export function deleteAtlas(params) {
  return request({
    url: '/atlas/deleteAtlas/' + params,
    method: 'get'
  })
}

//查询单个图集的基本信息
export function getAtlas(params) {
  return request({
    url: '/atlas/getAtlas/' + params,
    method: 'get'
  })
}

//查询单个图集的详细信息
export function getAtlasInfo(params) {
  return request({
    url: '/atlas/getAtlasInfo/' + params,
    method: 'get'
  })
}

//修改图集信息
export function updateAtlas(data) {
  return request({
    url: '/atlas/updateAtlas',
    method: 'post',
    data
  })
}

//图集取消归档
export function unFormatAtlas(params) {
  return request({
    url: '/atlas/unFormatAtlas/' + params,
    method: 'get'
  })
}


//将图片移除图集
export function removePictureAtlas(params) {
  return request({
    url: '/atlas/removePicture',
    method: 'get',
    params
  })
}

//将图片设为封面
export function setIndexpic(params) {
  return request({
    url: '/atlas/setIndexpic',
    method: 'get',
    params
  })
}


//获取图集中所有图片的编号
export function getAtlasSonIds(params) {
  return request({
    url: '/atlas/getAtlasSonIds/' + params,
    method: 'get'
  })
}




//自动构建封面
export function generateIndexPic(params) {
  return request({
    url: '/atlas/generateIndexPic',
    method: 'get',
    params
  })
}


//批量修改图集信息
export function batchUpdateAtlas(params,data) {
  return request({
    url: '/atlas/batchUpdateAtlas',
    method: 'post',
    params,
    data
  })
}